module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Challenged.d4be53bb.svg";